/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Gc_SubtitleInputs */

const en_gc_resources_compare_gc_subtitle = /** @type {(inputs: Gc_Resources_Compare_Gc_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open-source spreadsheet`)
};

const zh_gc_resources_compare_gc_subtitle = /** @type {(inputs: Gc_Resources_Compare_Gc_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源电子表格`)
};

/**
* | output |
* | --- |
* | "Open-source spreadsheet" |
*
* @param {Gc_Resources_Compare_Gc_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_gc_subtitle = /** @type {((inputs?: Gc_Resources_Compare_Gc_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Gc_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_gc_subtitle(inputs)
	return zh_gc_resources_compare_gc_subtitle(inputs)
});
export { gc_resources_compare_gc_subtitle as "gc.resources.compare.gc_subtitle" }